document.addEventListener('DOMContentLoaded', function () {
/* ----------------------------------
	 * Sticky Header 
	 * ---------------------------------- */
	const header = document.getElementById('masthead');

	if (header) {
		let lastScrollY = window.scrollY;
		const SCROLL_OFFSET = 80;

		const handleHeaderScroll = () => {
			const currentScrollY = window.scrollY;

			if (currentScrollY > SCROLL_OFFSET) {
				header.classList.toggle(
					'is-hidden',
					currentScrollY > lastScrollY
				);
			} else {
				header.classList.remove('is-hidden');
			}

			lastScrollY = currentScrollY;
		};

		window.addEventListener('scroll', handleHeaderScroll, { passive: true });
	}

	/* ----------------------------------
	 * Mobile Menu Toggle
	 * ---------------------------------- */
	const toggle = document.querySelector('.menu-toggle');
	const panel = document.querySelector('.menu-panel');

	if (toggle && panel) {
		const toggleMenu = () => {
			const isOpen = panel.classList.toggle('is-open');
			toggle.classList.toggle('is-open', isOpen);
			document.body.style.overflow = isOpen ? 'hidden' : '';
		};

		toggle.addEventListener('click', toggleMenu);
	}



  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.warn("GSAP or ScrollTrigger not loaded");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  const isReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ────────────────────────────────────────────────
  // 1. Simple fade + slide up
  // ────────────────────────────────────────────────
  function fadeUp(el, options = {}) {
    if (!el || isReducedMotion) return;

    const {
      trigger = el,
      start = "top 85%",
      duration = 0.9,
      delay = 0,
      y = 50,
      ease = "power3.out"
    } = options;

    gsap.set(el, { opacity: 0, y });

    ScrollTrigger.create({
      trigger,
      start,
      once: true,
      onEnter: () => {
        gsap.to(el, { opacity: 1, y: 0, duration, delay, ease });
      }
    });
  }

  // ────────────────────────────────────────────────
  // 2. Staggered children fade-up
  // ────────────────────────────────────────────────
  function staggerFadeUp(container, options = {}) {
    if (!container || isReducedMotion) return;

    const children = Array.from(container.children);
    if (!children.length) return;

    const {
      trigger = container,
      start = "top 85%",
      stagger = 0.12,
      duration = 0.85,
      y = 60,
      ease = "power3.out"
    } = options;

    gsap.set(children, { opacity: 0, y });

    ScrollTrigger.create({
      trigger,
      start,
      once: true,
      onEnter: () => {
        gsap.to(children, {
          opacity: 1,
          y: 0,
          duration,
          stagger,
          ease
        });
      }
    });
  }

  // ────────────────────────────────────────────────
  // 3. Image reveal with clip-path wipe (left → right)
  // ────────────────────────────────────────────────
  function imageWipeReveal(img, options = {}) {
    if (!img || isReducedMotion) return;

    const {
      trigger = img.parentElement || img,
      start = "top 82%",
      duration = 0.9,
      delay = 0.08,
      ease = "power3.out"
    } = options;

    gsap.set(img, { clipPath: "inset(0 100% 0 0)" });

    ScrollTrigger.create({
      trigger,
      start,
      once: true,
      onEnter: () => {
        gsap.to(img, {
          clipPath: "inset(0 0% 0 0)",
          duration,
          delay,
          ease
        });
      }
    });
  }

  // ────────────────────────────────────────────────
  // 4. CTA / Button entrance
  // ────────────────────────────────────────────────
  function ctaReveal(btn, delay = 0.4) {
    if (!btn || isReducedMotion) return;

    gsap.set(btn, { opacity: 0, y: 35 });

    ScrollTrigger.create({
      trigger: btn.parentElement || btn,
      start: "top 88%",
      once: true,
      onEnter: () => {
        gsap.to(btn, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          delay,
          ease: "power3.out"
        });
      }
    });
  }
  // ────────────────────────────────────────────────
  // 4. Image Zoom Fade
  // ────────────────────────────────────────────────

  function imageZoomFade(img, options = {}) {
    if (!img || isReducedMotion) return;
  
    const {
      trigger = img.parentElement || img,
      start = "top 82%",
      duration = 1.5,
      delay = 0.2,
      scaleStart = 1.12,
      ease = "power3.out"
    } = options;
  
    gsap.set(img, { 
      scale: scaleStart, 
      opacity: 0 
    });
  
    ScrollTrigger.create({
      trigger,
      start,
      once: true,
      onEnter: () => {
        gsap.to(img, {
          scale: 1,
          opacity: 1,
          duration,
          delay,
          ease
        });
      }
    });
  }

  // ────────────────────────────────────────────────
// GLOBAL PAGE HERO ANIMATION (ALL PAGES)
// ────────────────────────────────────────────────
const pageHeroTitle = document.querySelector(
  '.page-hero-wrapper .page-hero-content .heading-1'
);

if (pageHeroTitle) {
  fadeUp(pageHeroTitle, {
    y: 90,
    duration: 1.2,
    delay: 0.25,
    start: "top 88%",
    ease: "power3.out"
  });
}

  // ────────────────────────────────────────────────
  // HOMEPAGE ANIMATIONS
  // ────────────────────────────────────────────────

  // Hero / Banner
  const bannerHeading = document.querySelector(".home-banner-content .heading-1");
  const bannerText = document.querySelector(".home-banner-content p.body-3");
  const bannerBtn = document.querySelector(".home-banner-content .btn-secondary");

  if (bannerHeading) fadeUp(bannerHeading, { delay: 0.2 });
  if (bannerText) fadeUp(bannerText, { delay: 0.45 });
  if (bannerBtn) ctaReveal(bannerBtn, 0.75);

  // Introduction section
  const introHeading = document.querySelector(".home-intro-content .heading-3");
  const introText = document.querySelector(".home-intro-content .body-5");
  const introBtn = document.querySelector(".home-intro-content .btn-secondary");
  const introImage = document.querySelector(".home-intro-image img");

  if (introHeading) fadeUp(introHeading, { delay: 0.1 });
  if (introText) fadeUp(introText, { delay: 0.3 });
  if (introBtn) ctaReveal(introBtn, 0.55);
  if (introImage) imageWipeReveal(introImage, { duration: 1.6, delay: 0.35 });

  // Services section
  const servicesTitle = document.querySelector(".services .heading-2");
  const servicesGrid = document.querySelector(".services-grid");

  if (servicesTitle) {
    fadeUp(servicesTitle, { start: "top 88%" });
  }

  if (servicesGrid) {
    staggerFadeUp(servicesGrid, {
      stagger: 0.16,
      y: 70,
      duration: 1,
      start: "top 80%"
    });
  }

  const viewServicesBtn = document.querySelector(".view-services-btn .btn-secondary");
  if (viewServicesBtn) {
    ctaReveal(viewServicesBtn, 0.5);
  }

  document.querySelectorAll(".service-card").forEach((card) => {
    card.addEventListener("mouseenter", () => {
      gsap.to(card, {
        scale: 1.028,
        duration: 0.45,
        ease: "power2.out"
      });
    });

    card.addEventListener("mouseleave", () => {
      gsap.to(card, {
        scale: 1,
        duration: 0.45,
        ease: "power2.out"
      });
    });
  });

  window.addEventListener("load", () => {
    ScrollTrigger.refresh();
  });

  // ────────────────────────────────────────────────
  // SERVICES PAGE SPECIFIC ANIMATIONS
  // ────────────────────────────────────────────────
  if (
    document.body.classList.contains('page-template-page-services') ||
    document.querySelector('.page-hero-wrapper')
  ) {
    // 1. Hero 

    // 2. Intro descriptive text 
    const introText = document.querySelector('.services .body-1.text-center');
    if (introText) {
      fadeUp(introText, {
        y: 40,
        duration: 1.0,
        delay: 0.15,
        start: "top 85%"
      });
    }

    // 3. Services cards grid
    const servicesGrid = document.querySelector('.services-grid');
    if (servicesGrid) {
      staggerFadeUp(servicesGrid, {
        stagger: 0.14,
        y: 80,
        duration: 1.0,
        start: "top 78%",
        ease: "power3.out"
      });

      document.querySelectorAll('.services-grid .service-card').forEach(card => {
        card.addEventListener('mouseenter', () => {
          gsap.to(card, {
            scale: 1.035,
            duration: 0.45,
            ease: "power2.out"
          });
        });

        card.addEventListener('mouseleave', () => {
          gsap.to(card, {
            scale: 1,
            duration: 0.45,
            ease: "power2.out"
          });
        });
      });
    }

    // 4. Gallery section(s) – "Caught in Action"
    document.querySelectorAll('.gallery-grid').forEach((gallery, index) => {
      // Title above gallery
      const galleryTitle = gallery.previousElementSibling;
      if (galleryTitle && galleryTitle.matches('h2')) {
        fadeUp(galleryTitle, {
          y: 50,
          duration: 0.9,
          delay: 0.1 + index * 0.15,
          start: "top 82%"
        });
      }

      // Gallery items – staggered scale + fade
      const items = gallery.querySelectorAll('.gallery-item');
      if (items.length > 0) {
        gsap.set(items, { opacity: 0, scale: 0.92, y: 40 });

        ScrollTrigger.create({
          trigger: gallery,
          start: "top 80%",
          once: true,
          onEnter: () => {
            gsap.to(items, {
              opacity: 1,
              scale: 1,
              y: 0,
              duration: 0.9,
              stagger: 0.08,
              ease: "power3.out",
              delay: index * 0.12
            });
          }
        });
      }
    });

    // 5. All "View more" CTAs in gallery sections
    document.querySelectorAll('.gallery-grid').forEach(grid => {
      const toggleBtn = grid.nextElementSibling?.querySelector('.gallery-toggle-btn');
      if (!toggleBtn) return;

      const initialCount = parseInt(grid.dataset.initialVisible) || 4;
      const items = grid.querySelectorAll('.gallery-item');
      const total = items.length;

      if (total <= initialCount) return;

      toggleBtn.addEventListener('click', () => {
        const isExpanded = grid.classList.toggle('is-expanded');

        toggleBtn.classList.toggle('is-less', isExpanded);
        const label = toggleBtn.querySelector('.btn-label');
        if (label) {
          label.textContent = isExpanded ? 'View less' : 'View more';
        }        
      });
    });
  }

  // ────────────────────────────────────────────────
  // ABOUT US PAGE SPECIFIC ANIMATIONS
  // ────────────────────────────────────────────────
  if (document.body.classList.contains('page-template-about-us') ||
    document.querySelector('.page-hero-wrapper')) {

    // 1. Hero 

    // 2. Logistic / Overview section
    const logisticContent = document.querySelector('.logistic-content');
    const logisticImage = document.querySelector('.logistic-image img');

    if (logisticContent) {
      fadeUp(logisticContent.querySelector('h2'), { delay: 0.15 });
      fadeUp(logisticContent.querySelector('p'), { delay: 0.35 });
    }

    if (logisticImage) {
      imageZoomFade(logisticImage, {
        duration: 1.6,
        delay: 0.1,
        scaleStart: 1.15,
        start: "top 80%"
      });
    }

    // 3. Vision & Mission – two column style
    const visionBlock = document.querySelector('.vision');
    const missionBlock = document.querySelector('.mission');
    const vmImage = document.querySelector('.vision-mission__image img');

    if (visionBlock) {
      fadeUp(visionBlock.querySelector('h3'), { delay: 0.1 });
      fadeUp(visionBlock.querySelector('p'), { delay: 0.3 });
    }

    if (missionBlock) {
      fadeUp(missionBlock.querySelector('h3'), { delay: 0.25 });
      fadeUp(missionBlock.querySelector('p'), { delay: 0.45 });
    }

    if (vmImage) {
      imageWipeReveal(vmImage, {
        duration: 1.2,
        delay: 0,
        start: "top 100%"
      });
    }

    // 4. Why Choose Us – cards with icons
    const whyTitle = document.querySelector('.why-choose-us .why-title');
    const whyGrid = document.querySelector('.why-grid');

    if (whyTitle) {
      fadeUp(whyTitle, {
        y: 60,
        duration: 1.0,
        start: "top 85%"
      });
    }

    if (whyGrid) {
      staggerFadeUp(whyGrid, {
        stagger: 0.13,
        y: 70,
        duration: 0.95,
        start: "top 78%",
        ease: "power3.out"
      });

      document.querySelectorAll('.why-grid .why-card').forEach(card => {
        const icon = card.querySelector('.why-icon img');

        card.addEventListener('mouseenter', () => {
          gsap.to(card, { y: -8, duration: 0.4, ease: "power2.out" });
          if (icon) {
            gsap.to(icon, { scale: 1.15, duration: 0.5, ease: "power2.out" });
          }
        });

        card.addEventListener('mouseleave', () => {
          gsap.to(card, { y: 0, duration: 0.4, ease: "power2.out" });
          if (icon) {
            gsap.to(icon, { scale: 1, duration: 0.5, ease: "power2.out" });
          }
        });
      });
    }

    // 5. Commitment 
    const commitmentContent = document.querySelector('.commitment-content');
    const commitmentBgImage = document.querySelector('.commitment-bg img');

    if (commitmentContent) {
      fadeUp(commitmentContent.querySelector('p'), {
        y: 60,
        duration: 1.1,
        delay: 0.2,
        start: "top 82%"
      });
    }

    if (commitmentBgImage) {
      imageWipeReveal(commitmentBgImage, {
        duration: 1.4,
        delay: 0.1,
        start: "top 100%"
      });
    }
  }

  // ────────────────────────────────────────────────
  // CONTACT PAGE SPECIFIC ANIMATIONS
  // ────────────────────────────────────────────────
  if (
    document.body.classList.contains('page-template-page-contact') ||
    document.querySelector('.page-hero-wrapper')
  ) {  

  // 1. Hero 

  // 2. Contact section title – faster
  const contactTitle = document.querySelector('.contact-title.heading-3');
  if (contactTitle) {
    fadeUp(contactTitle, {
      y: 40,
      duration: 0.8,       // ← was 1.0
      delay: 0.1,          // ← was 0.2
      start: "top 80%"
    });
  }

  // 3. Contact blocks – quicker stagger
  const contactBlocks = document.querySelectorAll('.contact-details .contact-block');
  if (contactBlocks.length > 0) {
    gsap.set(contactBlocks, { opacity: 0, y: 35 });

    ScrollTrigger.create({
      trigger: ".contact-details",
      start: "top 78%",      // ← earlier
      once: true,
      onEnter: () => {
        gsap.to(contactBlocks, {
          opacity: 1,
          y: 0,
          duration: 0.7,       // ← was 0.85
          stagger: 0.11,       // ← tighter stagger
          ease: "power3.out",
          delay: 0.1           // ← was 0.15
        });
      }
    });
  }

  // 4. India map – faster & more dynamic
  const indiaMapImg = document.querySelector('.india-map-bg img');
  if (indiaMapImg) {
    imageWipeReveal(indiaMapImg, {
      duration: 1.4,         // ← was 1.8
      delay: 0.15,           // ← was 0.45
      start: "top 78%",      // ← earlier
      // Keep subtle scale for premium feel, but faster
      onStart: () => {
        gsap.from(indiaMapImg, {
          scale: 1.03,
          duration: 1.6,       // ← shorter
          ease: "power2.out"
        });
      }
    });
  }

  // 5. Containers strip – now BOTTOM → TOP wipe + faster
  const containersStrip = document.querySelector('.contact-containers-strip img');
  if (containersStrip) {
    // Bottom → Top reveal
    gsap.set(containersStrip, { clipPath: "inset(100% 0 0 0)" });

    ScrollTrigger.create({
      trigger: ".contact-containers-section",
      start: "top 82%",       // ← earlier trigger
      once: true,
      onEnter: () => {
        gsap.to(containersStrip, {
          clipPath: "inset(0% 0 0 0)",
          duration: 1.4,        // ← was 1.9 – much faster
          ease: "power3.out",
          delay: 0.15           // ← was 0.3
        });
      }
    });
  }
}

});